import { AISettings } from "@/Settings/AISettings";

/**
 * Body of the Agents → Context tab at ``/agents/context``.
 *
 * Renders the same form as ``/settings/ai`` (org knowledge + personal MCP
 * connections). Imported from ``Settings/AISettings`` rather than copied
 * so both routes stay in sync while the feature lives in two places.
 *
 * Transitional: this content's eventual home is the Agents tabs view.
 * It still ships at ``/settings/ai`` because the Agents tabs are behind a
 * feature flag — pulling it out of Settings now would make AI context
 * configuration unreachable for orgs that haven't opted into the flag.
 * Once the flag is removed, delete the ``/settings/ai`` route and move
 * ``AISettings`` here.
 */
export function ContextTab() {
  return <AISettings />;
}
